module.exports = __webpack_public_path__ + "img/tamara.7c2fbcd5.png";